import { useTranslation } from 'react-i18next'
import { MAX_ZOOM, MIN_ZOOM, zoomIn as zoomInOp, zoomOut as zoomOutOp } from './transforms'

interface CanvasControlsProps {
  zoom: number
  onZoomChange: (next: number) => void
  onZoomToFit: () => void
  snapToGrid: boolean
  onToggleSnap: () => void
}

export function CanvasControls({
  zoom,
  onZoomChange,
  onZoomToFit,
  snapToGrid,
  onToggleSnap,
}: CanvasControlsProps) {
  const { t } = useTranslation()
  const pct = Math.round(zoom * 100)
  return (
    <div className="flex items-center gap-1 rounded border border-stone-300 bg-white px-1 py-1 text-xs shadow-sm dark:border-stone-700 dark:bg-stone-900">
      <button
        type="button"
        aria-label={t('canvas.controls.zoomOut')}
        onClick={() => onZoomChange(zoomOutOp(zoom))}
        disabled={zoom <= MIN_ZOOM}
        className="rounded px-1.5 py-0.5 text-stone-700 disabled:opacity-40 hover:enabled:bg-stone-100 dark:text-stone-300 dark:hover:enabled:bg-stone-800"
      >
        −
      </button>
      <span className="w-10 text-center tabular-nums">{pct}%</span>
      <button
        type="button"
        aria-label={t('canvas.controls.zoomIn')}
        onClick={() => onZoomChange(zoomInOp(zoom))}
        disabled={zoom >= MAX_ZOOM}
        className="rounded px-1.5 py-0.5 text-stone-700 disabled:opacity-40 hover:enabled:bg-stone-100 dark:text-stone-300 dark:hover:enabled:bg-stone-800"
      >
        +
      </button>
      <button
        type="button"
        onClick={onZoomToFit}
        className="ml-1 rounded border-l border-stone-200 pl-2 pr-1 text-stone-700 hover:bg-stone-100 dark:border-stone-800 dark:text-stone-300 dark:hover:bg-stone-800"
      >
        {t('canvas.controls.fit')}
      </button>
      <button
        type="button"
        aria-pressed={snapToGrid}
        onClick={onToggleSnap}
        className={[
          'ml-1 rounded border-l border-stone-200 pl-2 pr-1 dark:border-stone-800',
          snapToGrid
            ? 'text-sky-600 dark:text-sky-400'
            : 'text-stone-700 dark:text-stone-300',
        ].join(' ')}
      >
        {t('canvas.controls.snap')}
      </button>
    </div>
  )
}
